import { render, staticRenderFns } from "./statbrandshare.vue?vue&type=template&id=c20ecd7c&scoped=true"
import script from "./statbrandshare.vue?vue&type=script&lang=js"
export * from "./statbrandshare.vue?vue&type=script&lang=js"
import style0 from "./statbrandshare.vue?vue&type=style&index=0&id=c20ecd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20ecd7c",
  null
  
)

export default component.exports